import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type AvailableCatalogTagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AvailableCatalogTagsQuery = { __typename?: 'query_root', tags?: Types.Maybe<{ __typename?: 'TagEntityResponseCollection', data: Array<{ __typename?: 'TagEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'Tag', name: string, slug: string, title?: Types.Maybe<string>, description?: Types.Maybe<string>, isCatalogFilter?: Types.Maybe<boolean> }> }> }> };


export const AvailableCatalogTagsDocument = gql`
    query availableCatalogTags {
  tags {
    data {
      id
      attributes {
        name
        slug
        title
        description
        isCatalogFilter
      }
    }
  }
}
    `;
export function useAvailableCatalogTagsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableCatalogTagsQuery, AvailableCatalogTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCatalogTagsQuery, AvailableCatalogTagsQueryVariables>(AvailableCatalogTagsDocument, options);
      }
export function useAvailableCatalogTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCatalogTagsQuery, AvailableCatalogTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCatalogTagsQuery, AvailableCatalogTagsQueryVariables>(AvailableCatalogTagsDocument, options);
        }
export type AvailableCatalogTagsQueryHookResult = ReturnType<typeof useAvailableCatalogTagsQuery>;
export type AvailableCatalogTagsLazyQueryHookResult = ReturnType<typeof useAvailableCatalogTagsLazyQuery>;
export type AvailableCatalogTagsQueryResult = Apollo.QueryResult<AvailableCatalogTagsQuery, AvailableCatalogTagsQueryVariables>;